import { render, staticRenderFns } from "./newFour.vue?vue&type=template&id=30956496&scoped=true&"
import script from "./newFour.vue?vue&type=script&lang=js&"
export * from "./newFour.vue?vue&type=script&lang=js&"
import style0 from "./newFour.vue?vue&type=style&index=0&id=30956496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30956496",
  null
  
)

export default component.exports